// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateUruguayanDocument } from './uruguayan-document';
import { validateUruguayanPhoneNumber } from './uruguayan-phone-number';
import { validateUruguayanZipcode } from './uruguayan-zipcode';
import { validateUruguayanState } from './uruguayan-state';
import { validateUruguayanCity } from './uruguayan-city';
import { validateUruguayanAddress } from './uruguayan-address';
import { validateUruguayanStreetNumber } from './uruguayan-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);

  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'uruguayanDocument':
      return onlyWhen('field_uruguayan_document') && validateUruguayanDocument(userInputValue);

    case 'uruguayanPhoneNumber':
      return onlyWhen('field_uruguayan_phone_number') && validateUruguayanPhoneNumber(userInputValue);

    case 'uruguayanZipcode':
      return onlyWhen('field_uruguayan_zipcode') && validateUruguayanZipcode(userInputValue);

    case 'uruguayanState':
      return onlyWhen('field_uruguayan_state') && validateUruguayanState(userInputValue);

    case 'uruguayanCity':
      return onlyWhen('field_uruguayan_city') && validateUruguayanCity(userInputValue);

    case 'uruguayanAddress':
      return onlyWhen('field_uruguayan_address') && validateUruguayanAddress(userInputValue);

    case 'uruguayanStreetNumber':
      return onlyWhen('field_uruguayan_street_number') && validateUruguayanStreetNumber(userInputValue);

    default:
      return VALID;
  }
}
